import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useUpdateClientContactRole, useUpdateNativeContactRole } from '~/hooks/reactQuery/queries/useClientContactMutations';
import { useInvalidateContactIdentity } from '~/hooks/reactQuery/queries/useContactSummaryMutations';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse, ServerError } from '~/infra/error-response/ErrorResponse';
import { ROLE_FIELD_NAME, changeContactRoleModalTextsPath } from '../ChangeContactRoleModal.utils';
export const useChangeContactRole = (param)=>{
    let { clientId, contact, dismissModal, successToastTestId } = param;
    const { t } = useLocaleKeys(changeContactRoleModalTextsPath);
    const { t: errorTexts } = useLocaleKeys('errors');
    const { showSuccessToast } = useOverlayContext();
    const invalidateContactIdentity = useInvalidateContactIdentity();
    const { updateClientContactRole } = useUpdateClientContactRole();
    const { updateNativeContactRole } = useUpdateNativeContactRole();
    const [errorMessage, setErrorMessage] = useState(null);
    const userId = contact.userId();
    const saveRole = (role)=>userId != null ? updateNativeContactRole({
            userId,
            role,
            customerBusinessId: clientId
        }) : updateClientContactRole({
            clientContactId: contact.id(),
            role,
            version: contact.version()
        });
    const changeRole = async (values)=>{
        setErrorMessage(null);
        try {
            // WHY: the picker registers `required`, so handleSubmit never reaches here with an unset role
            await saveRole(values[ROLE_FIELD_NAME]);
        } catch (error) {
            if (new ErrorResponse(error).hasServerError(ServerError.ContactVersionMismatch)) {
                setErrorMessage(errorTexts.contact.modified());
                invalidateContactIdentity();
                return;
            }
            setErrorMessage(t.saveError());
            return;
        }
        showSuccessToast(t.roleChanged(), successToastTestId);
        dismissModal();
    };
    return {
        errorMessage,
        changeRole
    };
};
